//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get'
import canDownload from '~/mixins/canDownload'
import hasBooklets from '~/mixins/hasBooklets'

export default {
  mixins: [canDownload, hasBooklets],

  computed: {
    booklet() {
      return get(this.getBooklets(this.bookletsParams), 0)
    },

    calendar() {
      return get(this.getBooklets(this.bookletsParams), 1)
    },

    bookletsParams() {
      return { limit: 2, orderBy: 'id', orderDirection: 'asc' }
    },
  },

  beforeMount() {
    this.maybeFetchBooklets(this.bookletsParams)
  },
}
